import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import AddNewButton from 'components/ActionButtons/addNewButton';
import List from './list';
import AddDialog from './addDialog';
import ConfirmDialog from 'components/Dialogs/ConfirmDialog';
import * as CurrencyAction from 'store/actions/currency';
import { t } from 'i18next';
function Currency() {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [editData, setEditData] = React.useState(null);
  const [showDelete, setShowDelete] = React.useState(false);

  const dispatch = useDispatch();

  const currencies = useSelector((state) => state.other_maintenance.currencies);

  const headers = ['no', 'name', 'created_at', ''];
  React.useEffect(() => {
    dispatch(CurrencyAction.getAll({}));
  }, [CurrencyAction.getAll, dispatch]);

  return (
    <>
      <List
        headers={headers}
        data={currencies}
        onEdit={(data) => {
          setModalOpen(true);
          setEditData(data);
        }}
        onDelete={(data) => {
          setShowDelete(true);
          setEditData(data);
        }}
        buttons={
          <>
            <AddNewButton
              onClick={() => {
                setModalOpen(true);
                setEditData(null);
              }}
              type='currency'
            />
            <Button style={{ width: 95 }} size='sm' onClick={() => dispatch(CurrencyAction.getAll({}, true))}>
              <i className='fa fa-spinner mr-2' />
              {t('refresh')}
            </Button>
          </>
        }
      />
      <AddDialog
        title={
          editData ? t('information_other_currency.edit_currency') : t('information_other_currency.add_new_currency')
        }
        editData={editData}
        modalOpen={modalOpen}
        onToggle={(open) => setModalOpen(open)}
        onSubmit={(values) => {
          setModalOpen(false);
          if (editData) dispatch(CurrencyAction.update({ ...values, itemId: editData?._id }));
          else dispatch(CurrencyAction.save(values));
          setTimeout(() => dispatch(CurrencyAction.getAll({}, true)), 1000);
        }}
      />
      <ConfirmDialog
        modalOpen={showDelete}
        title={t('information_other_currency.add_new_currency')}
        body={`${t('confirm_delete')} ${editData?.name}?`}
        onToggle={() => setShowDelete(false)}
        onConfirm={() => {
          setShowDelete(false);
          dispatch(CurrencyAction.deleteData(editData?._id));
          setTimeout(() => dispatch(CurrencyAction.getAll({}, true)), 1000);
        }}
      />
    </>
  );
}

export default Currency;
